import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import swal from 'sweetalert2';
import {MatPaginator, MatSort} from '@angular/material';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import {takeUntil} from 'rxjs/operators';
import * as moment from 'moment';
import {UserTimeline} from '../../../dto/user-timeline';
import {DatePipe} from '@angular/common';
import {Market} from '../../../dto/market';
import {User} from '../../../dto/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {TrackingLocation} from '../../../dto/tracking-location';
import {MarketLevel} from '../../../dto/market-level';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {Endpoints} from '../../../config/endpoints';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';
import {window} from 'ngx-bootstrap/utils/facade/browser';

@Component({
    selector: 'app-timeline-by-date-range',
    templateUrl: './timeline-by-date-range.component.html',
    styleUrls: ['./timeline-by-date-range.component.scss']
})
export class TimelineByDateRangeComponent implements OnInit {

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    locationList: TrackingLocation[] = [];
    timelineList: UserTimeline[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    viewInOldFormat = false;
    displayedColumns = ['SN', 'From', 'To', 'Duration', 'Address', 'Distance', 'Interval'];

    user = new User();
    headers = [];
    exportData = [];
    progress: number;
    showProgressBar = false;
    waitForProgress = true;
    totalPages = 0;
    selectedTab = 'map';

    @ViewChild(DaterangepickerDirective, {static: true}) dateRangePicker: DaterangepickerDirective;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    dataSource: BaseDatasourceService<UserTimeline>;

    filters = {
        'UserId': null,
        FromDate: moment().set({hour: 0, minute: 0, second: 0}).format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        ToDate: moment().set({hour: 23, minute: 59, second: 59}).format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        FileType: null,
    };


    userType = 'ORGANIZATION_USER';

    isCalenderOpen = false;
    fromDate = moment();
    toDate = moment();
    moment = moment;
    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null, endDate: null};
    datePipe = new DatePipe('en-US');

    private _unsubscribeAll: Subject<any>;
    private isSelected: boolean;
    private isSelected1: boolean;
    private filename: string;
    private filetype: string;

    @HostListener('document:click', ['$event'])
    clickOut(event): void {
        if (!document.getElementById('date').contains(event.target)) {
            this.isCalenderOpen = false;
            this.dateRangePicker.hide();
        }
    }

    constructor(private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private router: Router, private generalBroadcastService: GeneralBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.generalBroadcastService.broadcastTitle('Timeline By Multiple Dates');
        this.generalBroadcastService.broadcastSelectedModuleId('LOCATION');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach(marketLevel => {
            this.markets[marketLevel.Rank] = [];
            this.selectedMarket[marketLevel.Rank] = null;
        });

        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.ranges = {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
            ],
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
        this.selectedRange.endDate = moment().subtract(0, 'days').startOf('day');

    }

    ngOnInit(): void {
        this._getUserList();
        this.userFilter.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }
            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this.dataSource = new BaseDatasourceService<UserTimeline>(this.service);
    }

    ngAfterViewInit(): void {

    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseFields: 'Id,Code,Name,Active',
            UserType: null,
            MarketIdList: marketIdList,
            PageNumber: 0,
            RecordsPerPage: 50,
            SearchKey: search
        }).subscribe(pUsers => {
            this.userList = pUsers;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    dateChangeListener(pEvent: any): void {
        this.filters.FromDate = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.filters.ToDate = this.datePipe.transform(this.selectedRange.endDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
        if (pEvent.startDate != null && pEvent.endDate != null) {
            this.reloadDatatable(true);
        }
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    reloadDatatable(pSearch?: boolean): void {
        if (!this.filters.UserId) {
            swal('Wrong Input', 'Please select a user', 'warning');
            return;
        }
        this.dataSource.fetchRemoteData(Endpoints.timeline_by_date_range, this.filters);
    }

    downloadReport(): void {
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="XLSX" id="input1" name="filetype" checked> XLSX' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="CSV"  id="input2" style="margin-left: 20px;"> CSV ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                this.isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                this.isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (this.isSelected || this.isSelected1) {
                    swal.enableConfirmButton();
                } else {
                    swal.disableConfirmButton();
                }
                this.filename = (<HTMLInputElement>document.getElementById('report')).value;
                if (this.isSelected) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (this.isSelected1) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                this.filters.FileType = this.filetype;
                window.location.href = this.service.generateGetUrl(Endpoints.export_timeline_by_date_range, this.filters, this.filename, true);
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }

}
